import "./SwipeableModals.scss";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import {
  FormControl,
  InputLabel,
  OutlinedInput,
  Select,
  MenuItem,
} from "@mui/material";
import BlueButton from "../../../components/BlueButton/BlueButton";
import { useState, useEffect } from "react";
import api from "../../../utils/api";
import { toast } from "react-toastify";
import { DataGrid } from "@mui/x-data-grid";
import DeleteUser from "./../../../assets/delete.svg";
import EditUser from "./../../../assets/edit-user.svg";

const commonLabelStyles = {
  background: "white",
  transformOrigin: "right top",
  transform: "translate(14px, -9px) scale(0.75)",
  right: 24,
  left: "auto",
  paddingLeft: "4px",
  paddingRight: "4px",
};

const CountriesSwipeableModals = ({
  open,
  onClose,
  onOpen,
  currentView,
  initialData = null,
  refreshData,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [countries, setCountries] = useState([]);
  const [governorates, setGovernorates] = useState([]);
  const [banks, setBanks] = useState([]);
  const [selectedBank, setSelectedBank] = useState(null);
  const [formData, setFormData] = useState({
    name: { ar: "", en: "" },
    country_id: "",
    governorate_id: "",
    delivery: "",
    currency: { ar: "", en: "" },
    value_added: "",
    country_code: "",
    name_ar: "",
    name_en: "",
  });

  useEffect(() => {
    getCountries();
  }, []);

  useEffect(() => {
    if (formData.country_id) {
      getGovernorates(formData.country_id);
    }
  }, [formData.country_id]);

  useEffect(() => {
    if (initialData && currentView === "viewBank") {
      getBanks(initialData.id);
    }
  }, [initialData, currentView]);

  useEffect(() => {
    if (currentView === "createShipping" || currentView === "editShipping") {
      getAllGovernorates();
    }
  }, [currentView]);

  const getAllGovernorates = async () => {
    try {
      const res = await api.get("/Governorates");
      setGovernorates(res.data.data);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (initialData) {
      switch (currentView) {
        case "editCountry":
          setFormData({
            name: {
              ar: initialData.name_ar || initialData.name?.ar || "",
              en: initialData.name_en || initialData.name?.en || "",
            },
            currency: {
              ar: initialData.currency_ar || initialData.currency?.ar || "",
              en: initialData.currency_en || initialData.currency?.en || "",
            },
            value_added: initialData.value_added || "",
            country_code: initialData.country_code || "",
          });
          break;
        case "editGovernorate":
          setFormData({
            name: {
              ar: initialData.name_ar || initialData.name?.ar || "",
              en: initialData.name_en || initialData.name?.en || "",
            },
            country_id: initialData.country_id || "",
            delivery: initialData.delivery || "",
          });
          break;
        case "editRegion":
          setFormData({
            name: {
              ar: initialData.name_ar || initialData.name?.ar || "",
              en: initialData.name_en || initialData.name?.en || "",
            },
            country_id: initialData.country_id || "",
            governorate_id: initialData.governorate_id || "",
          });
          break;
        case "editShipping":
          setFormData({
            ...formData,
            governorate_id: initialData.governorate_id
              ? Number(initialData.governorate_id)
              : "",
            delivery: initialData.delivery || "",
          });
          break;
        case "createBank":
          setFormData({
            ...formData,
            country_id: initialData.id || "",
            name_ar: "",
            name_en: "",
          });
          break;
        case "editBank":
          setFormData({
            ...formData,
            name_ar: selectedBank?.name_ar || "",
            name_en: selectedBank?.name_en || "",
            country_id: selectedBank?.country_id || initialData.id || "",
          });
          break;
        default:
          setFormData({
            name: { ar: "", en: "" },
            country_id: "",
            governorate_id: "",
            delivery: "",
            currency: { ar: "", en: "" },
            value_added: "",
            country_code: "",
            name_ar: "",
            name_en: "",
          });
      }
    } else {
      setFormData({
        name: { ar: "", en: "" },
        country_id: "",
        governorate_id: "",
        delivery: "",
        currency: { ar: "", en: "" },
        value_added: "",
        country_code: "",
        name_ar: "",
        name_en: "",
      });
    }
  }, [initialData, currentView, selectedBank]);

  const getCountries = async () => {
    try {
      const res = await api.get("/countries");
      setCountries(res.data.data);
    } catch (error) {
      console.error(error);
    }
  };

  const getGovernorates = async (countryId) => {
    try {
      const res = await api.get(`/Governorates?country_id=${countryId}`);
      setGovernorates(res.data.data);
    } catch (error) {
      console.error(error);
    }
  };

  const getBanks = async (countryId) => {
    try {
      const res = await api.get(`/banks?country_id=${countryId}`);
      setBanks(res.data.data || []);
    } catch (error) {
      console.error("Error fetching banks:", error);
      toast.error("حدث خطأ أثناء جلب البنوك");
    }
  };

  const handleDeleteBank = async (bankId) => {
    try {
      await api.delete(`/banks/${bankId}`);
      toast.success("تم حذف البنك بنجاح");
      // Refresh the banks list
      if (initialData) {
        getBanks(initialData.id);
      }
    } catch (error) {
      console.error("Error deleting bank:", error);
      toast.error("حدث خطأ أثناء حذف البنك");
    }
  };

  const handleBankSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const isEdit = currentView === "editBank";
      const endpoint = isEdit ? `/banks/${selectedBank.id}` : "/banks";
      const method = isEdit ? "put" : "post";

      const bankData = {
        name_ar: formData.name_ar,
        name_en: formData.name_en,
        country_id: formData.country_id,
      };

      await api[method](endpoint, bankData);

      toast.success(isEdit ? "تم تحديث البنك بنجاح" : "تم إضافة البنك بنجاح");

      // Refresh banks list if we're viewing a country's banks
      if (initialData) {
        getBanks(initialData.id);
      }

      // If editing, go back to view banks
      if (refreshData) {
        refreshData("viewBank");
      }

      // Close the modal
      onClose();
    } catch (error) {
      console.error("API Error:", error.response?.data || error.message);
      toast.error(
        error.response?.data?.message || error.message || "حدث خطأ ما",
      );
    } finally {
      setIsLoading(false);
    }
  };

  const handleShippingSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const isEdit = currentView === "editShipping";
      const endpoint = isEdit ? `/shipping/${initialData.id}` : "/shipping";
      const method = "post";

      const shippingData = new FormData();
      shippingData.append("governorate_id", formData.governorate_id);
      shippingData.append("delivery", formData.delivery);

      await api[method](endpoint, shippingData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      toast.success(
        isEdit ? "تم تحديث سعر الشحن بنجاح" : "تم إضافة سعر الشحن بنجاح",
      );

      if (refreshData) {
        refreshData();
      }
      onClose();
    } catch (error) {
      console.error("API Error:", error.response?.data || error.message);
      toast.error(
        error.response?.data?.message || error.message || "حدث خطأ ما",
      );
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      // Check if we're handling a bank form submission
      if (currentView.includes("Bank")) {
        return handleBankSubmit(e);
      }
      // Check if we're handling a shipping form submission
      if (currentView.includes("Shipping")) {
        return handleShippingSubmit(e);
      }
      // Correctly determine if this is an edit operation
      const isEdit = currentView.startsWith("edit");
      // Map the currentView to the correct type for API endpoints
      let type;
      if (currentView.includes("Country")) {
        type = "country";
      } else if (currentView.includes("Governorate")) {
        type = "governorate";
      } else if (currentView.includes("Region")) {
        type = "region";
      }
      // Map the type to the correct API endpoint
      const endpoints = {
        country: "countries",
        governorate: "Governorates",
        region: "cities",
      };
      const endpoint = `/${endpoints[type]}${
        isEdit ? `/${initialData.id}` : ""
      }`;
      const method = isEdit ? "put" : "post";

      // Prepare data to send
      let dataToSend = {};

      if (type === "country") {
        dataToSend = {
          "name[ar]": formData.name.ar,
          "name[en]": formData.name.en,
          "currency[ar]": formData.currency.ar,
          "currency[en]": formData.currency.en,
          value_added: formData.value_added,
          country_code: formData.country_code,
        };
      } else if (type === "governorate") {
        dataToSend = {
          "name[ar]": formData.name.ar,
          "name[en]": formData.name.en,
          country_id: formData.country_id,
          delivery: 0,
        };
      } else if (type === "region") {
        dataToSend = {
          "name[ar]": formData.name.ar,
          "name[en]": formData.name.en,
          country_id: formData.country_id,
          governorate_id: formData.governorate_id,
        };
      }

      // Make the API request with x-www-form-urlencoded
      await api[method](endpoint, dataToSend, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      });

      toast.success(
        isEdit
          ? `تم تحديث ${
              type === "country"
                ? "البلد"
                : type === "governorate"
                  ? "المحافظة"
                  : "المنطقة"
            } بنجاح`
          : `تم إضافة ${
              type === "country"
                ? "البلد"
                : type === "governorate"
                  ? "المحافظة"
                  : "المنطقة"
            } بنجاح`,
      );
      if (refreshData) {
        refreshData();
      }
      onClose();
    } catch (error) {
      console.error("API Error:", error.response?.data || error.message);
      toast.error(
        error.response?.data?.message || error.message || "حدث خطأ ما",
      );
    } finally {
      setIsLoading(false);
    }
  };

  const renderCountryForm = () => (
    <div className="user-modal">
      <p className="user-modal-p">
        {currentView === "createCountry" ? "اضافة بلد جديد" : "تعديل البلد"}
      </p>
      <form onSubmit={handleSubmit}>
        <FormControl sx={{ width: "100%" }} variant="outlined">
          <InputLabel htmlFor="name-ar" shrink sx={commonLabelStyles}>
            اسم البلد بالعربية
          </InputLabel>
          <OutlinedInput
            sx={{ borderRadius: "8px" }}
            required
            id="name-ar"
            value={formData.name.ar}
            onChange={(e) =>
              setFormData({
                ...formData,
                name: { ...formData.name, ar: e.target.value },
              })
            }
          />
        </FormControl>

        <FormControl sx={{ width: "100%" }} variant="outlined">
          <InputLabel htmlFor="name-en" shrink sx={commonLabelStyles}>
            اسم البلد بالانجليزية
          </InputLabel>
          <OutlinedInput
            sx={{ borderRadius: "8px" }}
            required
            id="name-en"
            value={formData.name.en}
            onChange={(e) =>
              setFormData({
                ...formData,
                name: { ...formData.name, en: e.target.value },
              })
            }
          />
        </FormControl>

        <FormControl sx={{ width: "100%" }} variant="outlined">
          <InputLabel htmlFor="currency-ar" shrink sx={commonLabelStyles}>
            العملة بالعربية
          </InputLabel>
          <OutlinedInput
            sx={{ borderRadius: "8px" }}
            required
            id="currency-ar"
            value={formData.currency.ar}
            onChange={(e) =>
              setFormData({
                ...formData,
                currency: { ...formData.currency, ar: e.target.value },
              })
            }
          />
        </FormControl>

        <FormControl sx={{ width: "100%" }} variant="outlined">
          <InputLabel htmlFor="currency-en" shrink sx={commonLabelStyles}>
            العملة بالانجليزية
          </InputLabel>
          <OutlinedInput
            sx={{ borderRadius: "8px" }}
            required
            id="currency-en"
            value={formData.currency.en}
            onChange={(e) =>
              setFormData({
                ...formData,
                currency: { ...formData.currency, en: e.target.value },
              })
            }
          />
        </FormControl>

        <FormControl sx={{ width: "100%" }} variant="outlined">
          <InputLabel htmlFor="country-code" shrink sx={commonLabelStyles}>
            كود الدولة
          </InputLabel>
          <OutlinedInput
            sx={{ borderRadius: "8px" }}
            required
            id="country-code"
            type="number"
            value={formData.country_code}
            onChange={(e) =>
              setFormData({ ...formData, country_code: e.target.value })
            }
          />
        </FormControl>

        <FormControl sx={{ width: "100%" }} variant="outlined">
          <InputLabel htmlFor="value-added" shrink sx={commonLabelStyles}>
            القيمة المضافة
          </InputLabel>
          <OutlinedInput
            sx={{ borderRadius: "8px" }}
            required
            id="value-added"
            type="number"
            value={formData.value_added}
            onChange={(e) =>
              setFormData({ ...formData, value_added: e.target.value })
            }
          />
        </FormControl>

        <BlueButton
          text={currentView === "createCountry" ? "اضافة" : "تحديث"}
          size="medium"
          type="submit"
          variant="fill"
          loading={isLoading}
        />
      </form>
    </div>
  );

  const renderGovernorateForm = () => (
    <div className="user-modal">
      <p className="user-modal-p">
        {currentView === "createGovernorate"
          ? "اضافة محافظة جديدة"
          : "تعديل المحافظة"}
      </p>
      <form onSubmit={handleSubmit}>
        <FormControl fullWidth>
          <InputLabel htmlFor="country-select" shrink sx={commonLabelStyles}>
            البلد
          </InputLabel>
          <Select
            required
            value={formData.country_id}
            onChange={(e) =>
              setFormData({ ...formData, country_id: e.target.value })
            }
            displayEmpty={true}
            sx={{ borderRadius: "8px" }}
          >
            {countries.map((country) => (
              <MenuItem key={country.id} value={country.id}>
                {country.name?.ar || country.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl sx={{ width: "100%" }} variant="outlined">
          <InputLabel htmlFor="name-ar" shrink sx={commonLabelStyles}>
            اسم المحافظة بالعربية
          </InputLabel>
          <OutlinedInput
            sx={{ borderRadius: "8px" }}
            required
            id="name-ar"
            value={formData.name.ar}
            onChange={(e) =>
              setFormData({
                ...formData,
                name: { ...formData.name, ar: e.target.value },
              })
            }
          />
        </FormControl>

        <FormControl sx={{ width: "100%" }} variant="outlined">
          <InputLabel htmlFor="name-en" shrink sx={commonLabelStyles}>
            اسم المحافظة بالانجليزية
          </InputLabel>
          <OutlinedInput
            sx={{ borderRadius: "8px" }}
            required
            id="name-en"
            value={formData.name.en}
            onChange={(e) =>
              setFormData({
                ...formData,
                name: { ...formData.name, en: e.target.value },
              })
            }
          />
        </FormControl>

        <BlueButton
          text={currentView === "createGovernorate" ? "اضافة" : "تحديث"}
          size="medium"
          variant="fill"
          type="submit"
          loading={isLoading}
        />
      </form>
    </div>
  );

  const renderRegionForm = () => (
    <div className="user-modal">
      <p className="user-modal-p">
        {currentView === "createRegion" ? "اضافة منطقة جديدة" : "تعديل المنطقة"}
      </p>
      <form onSubmit={handleSubmit}>
        <FormControl fullWidth>
          <InputLabel htmlFor="country-select" shrink sx={commonLabelStyles}>
            البلد
          </InputLabel>
          <Select
            required
            value={formData.country_id}
            onChange={(e) =>
              setFormData({ ...formData, country_id: e.target.value })
            }
            displayEmpty={true}
            sx={{ borderRadius: "8px" }}
          >
            {countries.map((country) => (
              <MenuItem key={country.id} value={country.id}>
                {country.name?.ar || country.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl fullWidth>
          <InputLabel
            htmlFor="governorate-select"
            shrink
            sx={commonLabelStyles}
          >
            المحافظة
          </InputLabel>
          <Select
            required
            value={formData.governorate_id}
            onChange={(e) =>
              setFormData({ ...formData, governorate_id: e.target.value })
            }
            displayEmpty={true}
            sx={{ borderRadius: "8px" }}
          >
            {governorates.map((governorate) => (
              <MenuItem key={governorate.id} value={governorate.id}>
                {governorate.name_ar || governorate.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl sx={{ width: "100%" }} variant="outlined">
          <InputLabel htmlFor="name-ar" shrink sx={commonLabelStyles}>
            اسم المنطقة بالعربية
          </InputLabel>
          <OutlinedInput
            sx={{ borderRadius: "8px" }}
            required
            id="name-ar"
            value={formData.name.ar}
            onChange={(e) =>
              setFormData({
                ...formData,
                name: { ...formData.name, ar: e.target.value },
              })
            }
          />
        </FormControl>

        <FormControl sx={{ width: "100%" }} variant="outlined">
          <InputLabel htmlFor="name-en" shrink sx={commonLabelStyles}>
            اسم المنطقة بالانجليزية
          </InputLabel>
          <OutlinedInput
            sx={{ borderRadius: "8px" }}
            required
            id="name-en"
            value={formData.name.en}
            onChange={(e) =>
              setFormData({
                ...formData,
                name: { ...formData.name, en: e.target.value },
              })
            }
          />
        </FormControl>

        <BlueButton
          text={currentView === "createRegion" ? "اضافة" : "تحديث"}
          size="medium"
          variant="fill"
          type="submit"
          loading={isLoading}
        />
      </form>
    </div>
  );

  const renderViewBankView = () => {
    // Define columns for the banks DataGrid
    const bankColumns = [
      { field: "id", headerName: "ID", width: 70 },
      { field: "name_ar", headerName: "اسم البنك (العربية)", width: 180 },
      { field: "name_en", headerName: "اسم البنك (الإنجليزية)", width: 180 },
      {
        field: "actions",
        headerName: "الإجراءات",
        width: 150,
        renderCell: (params) => (
          <div className="cell-action">
            <div
              className="cell-btn"
              onClick={() => {
                setSelectedBank(params.row);
                if (refreshData) {
                  refreshData("editBank");
                }
              }}
            >
              <img src={EditUser} alt="تعديل" />
            </div>
            <div
              className="cell-btn"
              onClick={() => handleDeleteBank(params.row.id)}
            >
              <img src={DeleteUser} alt="حذف" />
            </div>
          </div>
        ),
      },
    ];

    return (
      <div className="user-modal">
        <p className="user-modal-p">البنوك</p>
        <DataGrid
          sx={{ backgroundColor: "white", width: "100%" }}
          autoHeight={true}
          columns={bankColumns}
          rows={banks}
          disableVirtualization
          disableColumnFilter
          disableColumnMenu
          hideFooter={banks.length <= 10}
          rowHeight={60}
        />
        <div style={{ marginTop: "20px" }}>
          <BlueButton
            text="إضافة بنك جديد"
            size="medium"
            variant="fill"
            onClick={() => {
              if (refreshData) {
                refreshData("createBank");
              }
            }}
          />
        </div>
      </div>
    );
  };

  const renderCreateBankView = () => (
    <div className="user-modal">
      <p className="user-modal-p">
        {currentView === "createBank" ? "اضافة بنك" : "تعديل البنك"}
      </p>
      <form onSubmit={handleBankSubmit}>
        <FormControl sx={{ width: "100%" }} variant="outlined">
          <InputLabel htmlFor="name-ar-bank" shrink sx={commonLabelStyles}>
            اسم البنك بالعربية
          </InputLabel>
          <OutlinedInput
            sx={{ borderRadius: "8px" }}
            required
            id="name-ar-bank"
            value={formData.name_ar}
            onChange={(e) =>
              setFormData({
                ...formData,
                name_ar: e.target.value,
              })
            }
          />
        </FormControl>

        <FormControl sx={{ width: "100%" }} variant="outlined">
          <InputLabel htmlFor="name-en-bank" shrink sx={commonLabelStyles}>
            اسم البنك بالانجليزية
          </InputLabel>
          <OutlinedInput
            sx={{ borderRadius: "8px" }}
            required
            id="name-en-bank"
            value={formData.name_en}
            onChange={(e) =>
              setFormData({
                ...formData,
                name_en: e.target.value,
              })
            }
          />
        </FormControl>

        <BlueButton
          text={currentView === "createBank" ? "اضافة" : "تحديث"}
          size="medium"
          variant="fill"
          type="submit"
          loading={isLoading}
        />
      </form>
    </div>
  );

  const renderShippingForm = () => (
    <div className="user-modal">
      <p className="user-modal-p">
        {currentView === "createShipping"
          ? "اضافة سعر شحن جديد"
          : "تعديل سعر الشحن"}
      </p>
      <form onSubmit={handleShippingSubmit}>
        <FormControl fullWidth>
          <InputLabel
            htmlFor="governorate-select"
            shrink
            sx={commonLabelStyles}
          >
            المحافظة
          </InputLabel>
          <Select
            required
            value={formData.governorate_id}
            onChange={(e) =>
              setFormData({ ...formData, governorate_id: e.target.value })
            }
            displayEmpty={true}
            sx={{ borderRadius: "8px" }}
          >
            {governorates.map((governorate) => (
              <MenuItem key={governorate.id} value={governorate.id}>
                {governorate.name_ar || governorate.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl sx={{ width: "100%" }} variant="outlined">
          <InputLabel htmlFor="delivery-price" shrink sx={commonLabelStyles}>
            سعر الشحن
          </InputLabel>
          <OutlinedInput
            sx={{ borderRadius: "8px" }}
            required
            id="delivery-price"
            type="number"
            value={formData.delivery}
            onChange={(e) =>
              setFormData({ ...formData, delivery: e.target.value })
            }
          />
        </FormControl>

        <BlueButton
          text={currentView === "createShipping" ? "اضافة" : "تحديث"}
          size="medium"
          variant="fill"
          type="submit"
          loading={isLoading}
        />
      </form>
    </div>
  );

  const views = {
    createCountry: renderCountryForm,
    editCountry: renderCountryForm,
    createGovernorate: renderGovernorateForm,
    editGovernorate: renderGovernorateForm,
    createRegion: renderRegionForm,
    editRegion: renderRegionForm,
    createBank: renderCreateBankView,
    editBank: renderCreateBankView,
    viewBank: renderViewBankView,
    createShipping: renderShippingForm,
    editShipping: renderShippingForm,
  };

  return (
    <SwipeableDrawer
      anchor="left"
      open={open}
      onClose={onClose}
      onOpen={onOpen}
      sx={{ zIndex: "1202" }}
      disableScrollLock
    >
      {(views[currentView] || (() => <div></div>))()}
    </SwipeableDrawer>
  );
};

export default CountriesSwipeableModals;
